/**
 * The identity detail page of one person — `cases/:caseId/identity/:identityId`
 * in `router.tsx`. Person ids are graph element ids (`4:…:37`), so the segment
 * is encoded.
 */
export function identityPath(caseId: string, personId: string): string {
  return `/cases/${caseId}/identity/${encodeURIComponent(personId)}`
}

/**
 * Where to go after a merge folded *mergedId* into *survivorId* (ADR-0042): the
 * survivor's page when *pathname* is the merged identity's own page — that page
 * would otherwise show an identity that no longer exists — and null anywhere
 * else. Compared decoded, since a router may hand the path back either way.
 */
export function pathAfterMerge(
  pathname: string,
  caseId: string,
  mergedId: string,
  survivorId: string
): string | null {
  const onMergedPage =
    decodeURIComponent(pathname) === decodeURIComponent(identityPath(caseId, mergedId))
  return onMergedPage ? identityPath(caseId, survivorId) : null
}
